import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import SalesPersonsContainer from './containers/sales-persons/sales-persons.container';

export const SalesPersonsModule: React.FC = () => {
  return (
    <Route
      exact
      path={APP_ROUTES.SALES_PERSONS_MODULE.FULL_PATH}
      component={SalesPersonsContainer}
    />
  );
};
